import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Typography, Box, Card, CardContent } from "@mui/material";
import { Person } from '@mui/icons-material';
import axios from "axios";
import { indigo } from '@mui/material/colors';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      //const response = await axios.post("https://api.ejemplo.com/login", { email, password });
      //localStorage.setItem("token", response.data.token);

      localStorage.setItem("token", "*****");
      
      navigate("/select-company");
    } catch (error) {
      alert("Error en el login");
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: indigo[100],
      }}
    >
      <Card sx={{ maxWidth: 400, p: 3, boxShadow: 5, backgroundColor: '#f1f1f1' }}>
        <CardContent>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: 30 }}>
            <img src="/logo_mayaland_bn.png" alt="" style={{ width: '70%' }} />
          </div>

          <Typography variant="h5" textAlign="center" gutterBottom style={{color: indigo[500]}}>
            <Person />  Login...
          </Typography>

          <TextField fullWidth margin="normal" label="User" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} />
          <TextField fullWidth margin="normal" label="Password" type="password" variant="outlined" value={password} onChange={(e) => setPassword(e.target.value)} />

          <Button fullWidth variant="contained" onClick={handleLogin} sx={{ mt: 2, backgroundColor: indigo[500], color: '#fff' }}>
            Access
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
